module.exports = __webpack_public_path__ + "static/YMA22-23_WINNER_best.remort_hsbc-f92b1d7faecf1e8ffb19612db161bdc1.jpg";